export default function dateFromObjectId(id) {
	return new Date(parseInt(id.substring(0, 8), 16) * 1000);
}
